import { ENVIRONMENT_INITIALIZER, inject, makeEnvironmentProviders, Provider } from "@angular/core";
import { UserTelemetryService } from "./user-telemetry.service";
import { TelemetryConfig } from "./config";
import { TELEMETRY_CONFIGS } from "./tokens";

const ENVIRONMENT_PROVIDER: Provider[] = [
    {
        provide: ENVIRONMENT_INITIALIZER,
        multi: true,
        useFactory() {
            return () => inject(UserTelemetryService);
        }
    }
];

export function provideUserTelemetry(config: TelemetryConfig = {}) {
    return makeEnvironmentProviders([
        {
            provide: TELEMETRY_CONFIGS,
            useValue: config
        },
        ENVIRONMENT_PROVIDER
    ]);
}
